import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { useTranslation } from "@i18n";

function RemoveSyncModal({
  removeSync,
  setRemoveSync,
  handleCancel,
}: {
  removeSync: { modal: boolean; data: number | null };
  setRemoveSync: (next: { modal: boolean; data: number | null }) => void;
  handleCancel: (index: number) => void;
}) {
  const { t } = useTranslation();
  function closeRemoveSyncModal() {
    setRemoveSync({
      modal: false,
      data: null,
    });
  }
  return (
    <ModalStateDialogComponent
      // `padding` is not a declared prop of this modal; a JSX spread does not excess-property-check,
      // so no assertion is needed.
      {...{ padding: "2rem" }}
      width="26.25rem"
      headerTitle={
        <div className="flex flex-row justify-between w-full items-center font-bold text-2xl">
          {t("Remove Syncing")}
        </div>
      }
      onCancel={closeRemoveSyncModal}
      isVisible={removeSync.modal}
      modelContent={
        <div className="text-sm">
          {t(
            "Are you sure you want to remove this sync? No new files or folders uploaded to CUBE will show on Desktop and vice versa.",
          )}
        </div>
      }
      footerContent={
        <div className="flex flex-row gap-4">
          <ButtonComponent
            buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
            onClick={() => {
              handleCancel(removeSync.data!);
              closeRemoveSyncModal();
            }}
          >
            {t("Confirm")}
          </ButtonComponent>
          <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={closeRemoveSyncModal}>
            {t("Cancel")}
          </ButtonComponent>
        </div>
      }
    />
  );
}

export default RemoveSyncModal;
